// extracted by mini-css-extract-plugin
export default {"innerWrapper":"Tz-z","tooltipWrapper":"Uz-z","icon":"Vz-z","tooltip":"Wz-z","content":"Xz-z"};